import { selectedTheme } from "../styles/theme";

export const COLOR_MASTER = selectedTheme.master;
export const COLOR_MASTER_LIGHT = selectedTheme.masterLight;
export const COLOR_MASTER_HOVER = selectedTheme.masterHover;
/* */
export const COLOR_SECOND = selectedTheme.second;
export const COLOR_SECOND_LIGHT = selectedTheme.secondLight;
export const COLOR_SECOND_HOVER = selectedTheme.secondHover;
/* */
export const COLOR_ACCENT = selectedTheme.accent;
export const COLOR_ACCENT_HOVER = selectedTheme.accentHover;
/* */
export const COLOR_DANGER = selectedTheme.danger;
export const COLOR_DANGER_HOVER = selectedTheme.dangerHover;
/* */
export const COLOR_NEUTRAL_STRONG = selectedTheme.neutralStrong;
export const COLOR_NEUTRAL = selectedTheme.neutral;
export const COLOR_NEUTRAL_HOVER = selectedTheme.neutralHover;
export const COLOR_NEUTRAL_LIGHT = selectedTheme.neutralLight;
export const COLOR_SURFACE_SOFT = selectedTheme.surfaceSoft;
/* */

export const COLOR_SURFACE = selectedTheme.surface;
export const COLOR_SUCCESS = selectedTheme.success;
export const COLOR_SUCCESS_HOVER = selectedTheme.successHover;
